import { localize } from '@saviynt/common';

import { getMessageKey } from '../../../utils/utils';
import {
  CERTS_LIST_CANCELED_TAB,
  CERTS_LIST_DONE_TAB,
  CERTS_LIST_EXPIRED_TAB,
  CERTS_LIST_TODO_TAB,
} from '../constant';

export const getTooltipText = (tab, isAdmin, messages, intl) => {
  // Common tooltip messages
  if (tab === CERTS_LIST_EXPIRED_TAB) {
    return (
      messages.CERTS_LIST_EXPIRED_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_EXPIRED_TOOLTIP_TEXT'))
    );
  }

  if (tab === CERTS_LIST_CANCELED_TAB) {
    return (
      messages.CERTS_LIST_CANCELLED_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_CANCELLED_TOOLTIP_TEXT'))
    );
  }

  // Login basaed tooltip messages
  if (isAdmin && tab === CERTS_LIST_TODO_TAB) {
    return (
      messages.CERTS_LIST_ADMIN_TODO_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_ADMIN_TODO_TOOLTIP_TEXT'))
    );
  }

  if (isAdmin && tab === CERTS_LIST_DONE_TAB) {
    return (
      messages.CERTS_LIST_ADMIN_DONE_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_ADMIN_DONE_TOOLTIP_TEXT'))
    );
  }

  if (tab === CERTS_LIST_TODO_TAB) {
    return (
      messages.CERTS_LIST_TODO_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_TODO_TOOLTIP_TEXT'))
    );
  }

  if (tab === CERTS_LIST_DONE_TAB) {
    return (
      messages.CERTS_LIST_DONE_TOOLTIP_TEXT ||
      localize(intl, getMessageKey('CERTS_LIST_DONE_TOOLTIP_TEXT'))
    );
  }

  return null;
};

export default getTooltipText;
